import { StyledIcon } from 'src/components/foundations/foundations.styles';
import {
  TabPanel,
  TabsHeaderContainer,
} from 'src/components/molecules/Tabs/Tabs.styles';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const PageContainer = styled.div`
  min-width: 1020px;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.variant};
  min-height: 100vh;
  height: 100%;
`;

export const RoutingContainer = styled.div`
  padding: 20px;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.variant};
`;

export const SearchContainer = styled.div`
  padding: 8px 8px 8px 16px;
  display: flex;
  column-gap: 8px;
  border: solid 1px
    ${(props) => props.theme.atlas.semantic.color.outline.default};
  border-radius: 3px;
  max-width: 287px;
  align-items: center;
  height: 40px;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
`;

export const SearchBar = styled.input`
  border: none;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0;
`;

export const RoutingBody = styled.div`
  margin-top: 20px;
`;

export const RulesContainer = styled.ul<{ rows: number }>`
  display: flex;
  flex-direction: column;
  column-gap: 20px;
  list-style-type: none;
  padding: 0;
  margin: 0;
  position: relative;
`;

export const PriorityTitleContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 5px;
`;

export const RoutingSubtitle = styled.h3`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  margin: 0;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const PriorityInfo = styled(StyledIcon)`
  cursor: pointer;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  column-gap: 20px;
`;

export const PriorityParagraph = styled.p`
  margin: 0;
  margin-bottom: 20px;
`;

export const WarningParagraph = styled.p`
  margin: 0;
  margin-bottom: 20px;
`;

export const RoutingTabsWrapper = styled.div`
  ${TabsHeaderContainer} {
    background: transparent;
    padding-top: 0;
  }

  ${TabPanel} {
    padding: 0;
    background: transparent;
    border-radius: 0;
    margin-top: 20px;
  }
`;
